import { createGlobalStyle } from "styled-components";

export const LandingPageCss = createGlobalStyle`
    .parent-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 4rem;
    }
    .mic-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 20px;
    }
    .wave-div {
        height: 60px !important;
        background-color: rgba(0, 0, 0, 0.01);
        /* position: absolute;
        top: 30%;
        left: 37%; */
        width: 80% !important;
    }
    .recorder-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 20px;
    }
    .recorder-content input {
        background-color: white;
        border: 1px solid black;
        border-radius: 7px;
        padding: 5px 10px;
        color: black;
    }
    .recorder-content button {
        background-color: gray;
        color: black;
        height: 40px;
        width: 120px;
        border-radius: 10px;
    }
    /* }
    .mic-icon {
        color: #e30b0b;
    }
    .recorder-container {
        width: 150px;
        background-color: #bdc3c780;
        display: block;
        margin: 50px auto 0px auto;
        border-radius: 100%;
        box-shadow: 0px 0px 15px 2px #bdc3c7;
        cursor: default;
        transition: .3s all ease-in;
        position: relative;
    }

    .icon-microphone {
        color: #fff;
        font-size: 60px;
        line-height: 150px;
        display: block;
        text-align: center;
        transition: .1s all ease-in;
        position: relative;
        height: 26vh;
        width: 12vw;
        padding-top: 1vh;
        border: 3px solid #e30b0b;
        border-radius: 100%;
    }

    .outer {
        width: 148px;
        height: 148px;
        -webkit-transform: scale(1);
        border-radius: 100%;
        position: absolute;
        background-color: transparent;
        border: 1px solid #e30b0b;
        z-index: -1;
        transition: 1.5s all ease;
        -webkit-animation: woong 1.5s infinite;
    }

    .outer-2 {
        width: 150px;
        height: 150px;
        -webkit-transform: scale(1);
        border-radius: 100%;
        position: absolute;
        background-color: #e30b0b;
        z-index: -1;
        transition: 1.5s all ease;
        -webkit-animation: woong-2 1.5s infinite;
        -webkit-animation-delay: 2.5s;
    }

@-webkit-keyframes woong {
    0% {
        -webkit-trasform: scale(1.2);
    }
    50% {
        -webkit-transform: scale(1.8);
        opacity: 0.5;
    }
    100% {
        -webkit-transform: scale(2.4);
        opacity: 0;
    }
}

@-webkit-keyframes woong-2 {
    0% {
        -webkit-transform: scale(1.2);
        opacity: 0.6;
    }
    50% {
        -webkit-transform: scale(1.6);
        opacity: 0.5;
    }
    100% {
        -webkit-transform: scale(2);
        opacity: 0;
    }
} */

`;
